const FILE_BASE_URL = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

export async function openFileUrl(path, fileName) {
  try {
    const cleanedPath = String(path || "").replace(/^\/+/, "");
    if (!cleanedPath) {
      return false;
    }

    const fileUrl = FILE_BASE_URL
      ? `${FILE_BASE_URL}/${cleanedPath}`
      : `${window.location.origin}/${cleanedPath}`;

    const res = await fetch(fileUrl);
    if (!res.ok) {
      // fallback to opening direct URL
      window.open(fileUrl, "_blank", "noopener,noreferrer");
      return true;
    }

    const blob = await res.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    window.open(blobUrl, "_blank", "noopener,noreferrer");
    // revoke after a short timeout to allow browser to load
    setTimeout(() => {
      try {
        window.URL.revokeObjectURL(blobUrl);
      } catch (e) {
        // ignore
      }
    }, 20000);

    return true;
  } catch (err) {
    console.error("openFileUrl error:", err);
    return false;
  }
}

export default openFileUrl;
